<script setup>

// Props
const props = defineProps({
  block: {
    type: Object,
    default: () => ({})
  }
})

const cards = computed(() =>
  (props.block?.cards || []).filter((card) => card?.title || card?.textBlock)
)

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<template>
<section class="benefits-section section-mb">
  <div class="container">

    <div v-if="props.block?.heading?.html"
      class="benefits-section__heading"
      v-html="props.block.heading.html"></div>

    <div v-if="cards.length" class="benefits-section__cards">
      <div v-for="card in cards" :key="card.id" class="benefits-section__card">

        <div v-if="(card.iconField || [])[0]?.url" class="benefits-section__card-icon">
          <img
            :src="card.iconField[0].url"
            :alt="card.iconField[0].title || card.title"
            loading="lazy"
          />
        </div>

        <p v-if="card.title" class="benefits-section__card-title">{{ card.title }}</p>
        <p v-if="card.textBlock" class="benefits-section__card-text">{{ card.textBlock }}</p>

      </div>
    </div>

  </div>
</section>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.benefits-section__heading {
  margin-bottom: 36px;

  @media (min-width: 1024px) {
    margin-bottom: 40px;
  }
}

.benefits-section__heading :deep(*) {
  font-family: var(--font-family-heading);
  font-size: 28px;
  font-weight: 500;
  color: var(--color-gray-800);
  line-height: 132%;
  letter-spacing: -0.56px;

  @media (min-width: 1024px) {
    font-size: 38px;
    line-height: 120%;
    letter-spacing: -0.76px;
  }
}

.benefits-section__cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}

.benefits-section__card {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 16px;
  min-height: 246px;
  background-color: var(--color-gray-100);

  @media (min-width: 1024px) {
    padding: 40px 50px;
    min-height: 300px;
  }
}

.benefits-section__card-icon {
  display: flex;
  width: 40px;
  height: 40px;
  margin-bottom: 12px;
  @media (min-width: 1024px) {
    width: 48px;
    height: 48px;
    margin-bottom: 20px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.benefits-section__card-title {
  font-family: var(--font-family-primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 132%;
  letter-spacing: -0.36px;
  color: #292016;
  margin-bottom: 34px;

  @media (min-width: 1024px) {
    font-size: 28px;
    letter-spacing: -0.56px;
  }
}

.benefits-section__card-text {
  font-family: var(--font-family-primary);
  font-size: 16px;
  font-weight: 400;
  color: #736E68;
  line-height: 136%;
  letter-spacing: -0.32px;
  margin-top: auto;

  @media (min-width: 1024px) {
    font-size: 18px;
    letter-spacing: -0.36px;
  }
}

</style>

<style>

.page.--has-background-color .benefits-section__card {
  background-color: var(--color-white);
}

</style>